/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
import RenderFullPageLoading from "./assets/component/RenderFullPageLoading.js";

function run(Component, rest) {
  function renderComponent(t, props, isAuth, login, language) {
    const currentPath = props.location.pathname.substring(1).toUpperCase();
    const languageObj = t(currentPath, { returnObjects: true });

    return (
      <Component
        {...props}
        login={login}
        language={language}
        languageObj={languageObj}
        RenderFullPageLoading={RenderFullPageLoading}
      />
    );
  }

  return (
    <AuthConsumer>
      {({ t, isAuth, login, language }) => (
        <Route
          render={(props) =>
            isAuth ? (
              <Redirect to="/SelectMission" />
            ) : (
              renderComponent(t, props, isAuth, login, language)
            )
          }
          {...rest}
        />
      )}
    </AuthConsumer>
  );
}

const LoginRoute = ({ component: Component, ...rest }) => run(Component, rest);

export default LoginRoute;
